window.dataLayer = window.dataLayer || []

class DataLayerEvents {
  constructor () {
    this.ecommerce = {
      events: ['begin_checkout'],
      params: null
    }

    this.nodes = document.querySelectorAll('[data-event-category]')

    this.bindEvents()

    setTimeout(() => this.onCartUpdate(), 500)
    document.addEventListener('cart:updated', event => this.onCartUpdate(event))
  }

  bindEvents () {
    this.nodes.forEach((node) => {
      const eventCategory = node.dataset.eventCategory
      const eventAction = node.dataset.eventAction || node.innerText
      const eventLabel = node.dataset.eventLabel || location.href

      node.addEventListener('click', () => {
        this.dataLayer(eventCategory, eventAction, eventLabel)
      })
    })
  }

  dataLayer (eventCategory, eventAction, eventLabel) {
    // console.log({ eventCategory, eventAction, eventLabel })

    if (this.ecommerce.events.includes(eventCategory)) {
      window.dataLayer.push({
        ecommerce: null
      })
      window.dataLayer.push({
        ecommerce: this.ecommerce.params,
        event: eventCategory
      })
    } else {
      window.dataLayer.push({
        event: eventCategory,
        event_category: eventCategory,
        event_action: eventAction,
        event_label: eventLabel
      })
    }
  }

  onCartUpdate (event) {
    if (event?.detail) {
      this.ecommerce.params = this.parseCart(event.detail)
    } else {
      fetch('/cart.js')
        .then(response => response.json())
        .then((cart) => { this.ecommerce.params = this.parseCart(cart) })
        .catch(console.error)
    }
  }

  parseCart (cart) {
    const items = cart.items.map(item => ({
      item_id: item.sku,
      item_name: item.title,
      item_brand: item.vendor,
      item_category: item.product_type,
      price: item.price / 100,
      quantity: item.quantity
    }))

    return {
      currency: cart.currency,
      value: cart.total_price / 100,
      items
    }
  }
}

new DataLayerEvents()
